module.exports = ".mostrar-item {\n  height: 46px !important; }\n"